import Link from "next/link";
import { ChevronRight, type LucideIcon } from "lucide-react";
import type { TherapyGuideAccent } from "~/config/vodic-kroz-psihoterapiju";
import { cn } from "~/lib/utils";

interface AccentRowProps {
  href: string;
  icon: LucideIcon;
  title: string;
  description?: string;
  accent: TherapyGuideAccent;
}

export function AccentRow({
  href,
  icon: Icon,
  title,
  description,
  accent,
}: AccentRowProps) {
  if (!description) {
    return (
      <Link
        href={href}
        className="group flex min-w-0 items-center gap-3 rounded-lg border border-border/80 bg-background px-3 py-2.5 transition-colors hover:border-brand/40 hover:bg-muted/50"
      >
        <span className={cn("shrink-0 rounded-lg p-2", accent.badge)}>
          <Icon className="size-3.5" strokeWidth={1.5} aria-hidden="true" />
        </span>
        <span
          className="min-w-0 flex-1 truncate text-sm font-semibold text-foreground"
          title={title}
        >
          {title}
        </span>
        <ChevronRight
          className="size-4 shrink-0 text-muted-foreground/60 transition-transform group-hover:translate-x-0.5"
          aria-hidden="true"
        />
      </Link>
    );
  }

  return (
    <Link
      href={href}
      className="group flex min-w-0 items-start gap-3 rounded-xl border border-border/80 bg-background p-4 transition-colors hover:border-brand/40 hover:bg-muted/50"
    >
      <span className={cn("shrink-0 rounded-lg p-2.5", accent.badge)}>
        <Icon className="size-4" strokeWidth={1.5} aria-hidden="true" />
      </span>
      <div className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-foreground">
          {title}
        </span>
        <p
          className="mt-1 text-sm leading-relaxed text-muted-foreground"
          style={{
            display: "-webkit-box",
            overflow: "hidden",
            WebkitBoxOrient: "vertical",
            WebkitLineClamp: 5,
          }}
        >
          {description}
        </p>
      </div>
      <ChevronRight
        className="mt-1 size-4 shrink-0 text-muted-foreground/60 transition-transform group-hover:translate-x-0.5"
        aria-hidden="true"
      />
    </Link>
  );
}
